(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scord-faq"] && !Shopify.designMode) return;
  try {
    
/* FAQ search and category filter. Everything is client side. At 18
   questions that is the right call; a server round trip per keystroke
   would be slower and worse. Revisit past a few hundred entries. */
(function () {
  var controls = document.querySelector('[data-scord-faq-controls]');
  if (!controls) return;

  var input = controls.querySelector('[data-scord-faq-search]');
  var cats = controls.querySelector('[data-scord-faq-cats]');
  var countEl = controls.querySelector('[data-scord-faq-count]');
  var groups = [].slice.call(document.querySelectorAll('.group'));
  var items = [].slice.call(document.querySelectorAll('details[data-cat]'));
  var empty = document.querySelector('[data-scord-faq-empty]');
  var reset = document.querySelector('[data-scord-faq-reset]');

  var cat = 'all';
  var term = '';

  items.forEach(function (d) {
    d.dataset.text = d.textContent.toLowerCase().replace(/\s+/g, ' ');
    d.dataset.q = d.querySelector('summary').textContent;
  });

  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function plural(n) { return n + (n === 1 ? ' Question' : ' Questions'); }

  function clearMarks() {
    items.forEach(function (d) {
      var s = d.querySelector('summary');
      if (s.innerHTML.indexOf('<mark') > -1) s.textContent = d.dataset.q;
    });
  }

  function syncUrl() {
    if (!window.history || !window.history.replaceState) return;
    var p = new URLSearchParams();
    if (term) p.set('q', term);
    if (cat !== 'all') p.set('cat', cat);
    var qs = p.toString();
    history.replaceState(null, '', qs ? '?' + qs : location.pathname);
  }

  function apply() {
    var n = 0;
    clearMarks();

    items.forEach(function (d) {
      var okCat = cat === 'all' || d.dataset.cat === cat;
      var okTerm = !term || d.dataset.text.indexOf(term) > -1;
      var show = okCat && okTerm;

      d.classList.toggle('hide', !show);
      if (!show) { d.open = false; return; }
      n++;

      if (term) {
        d.open = true;
        var s = d.querySelector('summary');
        var q = d.dataset.q;
        if (q.toLowerCase().indexOf(term) > -1) {
          s.innerHTML = q.replace(new RegExp('(' + esc(term) + ')', 'ig'), '<mark>$1</mark>');
        }
      } else {
        d.open = false;
      }
    });

    groups.forEach(function (g) {
      var vis = g.querySelectorAll('details:not(.hide)').length;
      g.classList.toggle('hide', vis === 0);
      var c = g.querySelector('.gh .c');
      if (c) c.textContent = plural(vis);
    });

    if (empty) empty.classList.toggle('hide', n > 0);
    if (countEl) countEl.textContent = plural(n);
    syncUrl();
  }

  cats.addEventListener('click', function (e) {
    var b = e.target.closest('.chip');
    if (!b) return;
    cat = b.dataset.cat;
    [].forEach.call(this.querySelectorAll('.chip'), function (x) {
      x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
    });
    apply();
  });

  var timer;
  input.addEventListener('input', function () {
    clearTimeout(timer);
    var v = this.value.trim().toLowerCase();
    timer = setTimeout(function () { term = v; apply(); }, 140);
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && this.value) { this.value = ''; term = ''; apply(); }
  });

  function resetAll() {
    input.value = '';
    term = '';
    cat = 'all';
    [].forEach.call(cats.querySelectorAll('.chip'), function (x) {
      x.setAttribute('aria-pressed', x.dataset.cat === 'all' ? 'true' : 'false');
    });
    apply();
    input.focus();
  }

  if (reset) reset.addEventListener('click', resetAll);

  var params = new URLSearchParams(location.search);
  if (params.get('q')) { input.value = params.get('q'); term = params.get('q').toLowerCase(); }
  if (params.get('cat')) {
    var target = cats.querySelector('[data-cat="' + params.get('cat') + '"]');
    if (target) {
      cat = params.get('cat');
      [].forEach.call(cats.querySelectorAll('.chip'), function (x) {
        x.setAttribute('aria-pressed', x === target ? 'true' : 'false');
      });
    }
  }

  apply();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scord-join"] && !Shopify.designMode) return;
  try {
    
(function () {
  var KLAVIYO_COMPANY_ID = 'SWKVRT';
  var KLAVIYO_REVISION = '2024-10-15';

  function initForm(form) {
    if (form.dataset.klaviyoWired) return;
    form.dataset.klaviyoWired = 'true';

    var emailInput = form.querySelector('input[name="email"]');
    var success = form.querySelector('[data-join-success]');
    var error = form.querySelector('[data-join-error]');
    var button = form.querySelector('button[type="submit"]');
    var listId = form.getAttribute('data-klaviyo-list-id');

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      success.hidden = true;
      error.hidden = true;

      var email = (emailInput.value || '').trim();
      if (!email || !emailInput.checkValidity()) {
        error.hidden = false;
        return;
      }

      button.disabled = true;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'revision': KLAVIYO_REVISION
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: listId } }
            }
          }
        })
      })
        .then(function (res) {
          button.disabled = false;
          if (res.ok) {
            form.reset();
            success.hidden = false;
          } else {
            error.hidden = false;
          }
        })
        .catch(function () {
          button.disabled = false;
          error.hidden = false;
        });
    });
  }

  document.querySelectorAll('.scord-klaviyo-join-form').forEach(initForm);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scord-legal"] && !Shopify.designMode) return;
  try {
    
/* Build the table of contents from the document's own headings, then
   highlight the section currently in view. If there are no headings the
   TOC stays hidden rather than showing an empty box. */
(function () {
  var doc = document.querySelector('[data-scord-doc]');
  var toc = document.querySelector('[data-scord-toc]');
  if (!doc || !toc) return;

  var headings = doc.querySelectorAll('h2');
  if (!headings.length) return;

  var list = toc.querySelector('ol');
  var links = [];

  Array.prototype.forEach.call(headings, function (h, i) {
    if (!h.id) {
      h.id = 'section-' + (i + 1) + '-' +
        h.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent;
    li.appendChild(a);
    list.appendChild(li);
    links.push(a);
  });

  toc.hidden = false;

  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      links.forEach(function (a) { a.classList.remove('on'); });
      var match = links.filter(function (a) {
        return a.getAttribute('href') === '#' + e.target.id;
      })[0];
      if (match) {
        match.classList.add('on');
        if (list.scrollHeight > list.clientHeight) {
          list.scrollTo({ top: match.offsetTop - list.clientHeight / 2, behavior: 'smooth' });
        }
      }
    });
  }, { rootMargin: '-20% 0px -70% 0px' });

  Array.prototype.forEach.call(headings, function (h) { io.observe(h); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scord-product-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wraps = document.querySelectorAll('[data-scord-video]');
  if (!wraps.length) return;
  Array.prototype.forEach.call(wraps, function (wrap) {
    var video = wrap.querySelector('video');
    if (!video) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    function applyReduced() {
      if (reduce.matches) {
        video.removeAttribute('autoplay');
        video.setAttribute('controls', '');
        video.pause();
      } else {
        video.removeAttribute('controls');
        var p = video.play();
        if (p && p.catch) { p.catch(function () {}); }
      }
    }
    applyReduced();
    if (reduce.addEventListener) reduce.addEventListener('change', applyReduced);
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (reduce.matches) return;
        if (e.isIntersecting) {
          var p = video.play();
          if (p && p.catch) { p.catch(function () {}); }
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.2 });
    io.observe(video);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
